"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { DEFAULT_FLAG_VALUES, isMountCriticalFlag } from './mount-critical-flags';
/**
 * Reads mount-critical feature flags from window.__AG_FEATURE_FLAGS__
 * These flags are injected by the Lambda@Edge HTML generator at request time.
 *
 * @returns The mount-critical flag values, with defaults for any missing flags
 */
export const getMountCriticalFlags = () => {
  if (typeof window === 'undefined' || !window.__AG_FEATURE_FLAGS__) {
    return _objectSpread({}, DEFAULT_FLAG_VALUES);
  }
  const windowFlags = window.__AG_FEATURE_FLAGS__;
  const result = _objectSpread({}, DEFAULT_FLAG_VALUES);
  for (const [key, value] of Object.entries(windowFlags)) {
    if (isMountCriticalFlag(key) && typeof value === 'boolean') {
      result[key] = value;
    }
  }
  return result;
};

/**
 * Gets a single mount-critical flag value from window.__AG_FEATURE_FLAGS__
 *
 * @param flag The flag to retrieve
 * @returns The flag value, or the default if not found
 */
export const getMountCriticalFlag = flag => {
  return getMountCriticalFlags()[flag];
};

/**
 * Checks if DataDog should be enabled based on mount-critical flags.
 * DataDog is enabled when 'datadog-enabled' flag is true.
 *
 * @returns true if DataDog should be initialised
 */
export const isDataDogEnabled = () => {
  return getMountCriticalFlag('datadog-enabled');
};

/**
 * Gets the DataDog configuration mode based on mount-critical flags.
 * Priority: high-fidelity > minimal > default
 *
 * @returns 'high-fidelity' | 'minimal' | 'default'
 */
export const getDataDogMode = () => {
  const flags = getMountCriticalFlags();
  if (flags['datadog-high-fidelity']) {
    return 'high-fidelity';
  }
  if (flags['datadog-minimal']) {
    return 'minimal';
  }
  return 'default';
};